import React from 'react';
import axios from 'axios';
import Loading from '../images/loading.gif';

export default function Background() {
  let loadingQueue = 0;

  const triggerLoadingIndicator = (index) => {
    loadingQueue += index;
    const element = document.getElementById('busy-indicator');
    if (loadingQueue > 0) {
      element.style.display = 'inherit';
    } else {
      element.style.display = 'none';
    }
  };

  axios.interceptors.request.use(
    (config) => {
      triggerLoadingIndicator(+1);
      return config;
    },
    (err) => {
      triggerLoadingIndicator(+1);
      return Promise.reject(err);
    },
  );

  axios.interceptors.response.use(
    (response) => {
      triggerLoadingIndicator(-1);
      return response;
    },
    (err) => {
      triggerLoadingIndicator(-1);
      return Promise.reject(err);
    },
  );

  return (
    <div>
      <div id="busy-indicator">
        <img src={Loading} alt="loading" />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Background.jsx